export interface LegendProps {
  variant?: string;
  legend: string;
  description?: string;
}

const Legend = ({ variant, legend, description }: LegendProps) => (
  <legend
    className={`cef-ui-legend${variant ? ` cef-ui-legend--${variant}` : ''}`}>
    <div className="cef-ui-legend__title">{legend}</div>
    {description && (
      <div
        className="cef-ui-legend__description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    )}
  </legend>
);

export default Legend;
